import { UIText1, Button, ModalWindow, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NotAvailablePopup.css';

interface INotAvailablePopupProps {
  onClose(): void;
  onWriteMessage(): void;
  onCallAnyway(): void;
  onShow(): void;
  title: string;
  message: string;
  isChatEnabled: boolean;
}

export const NotAvailablePopup: React.FC<INotAvailablePopupProps> = ({
  onClose,
  onWriteMessage,
  onCallAnyway,
  onShow,
  title,
  message,
  isChatEnabled,
}) => {
  React.useEffect(onShow, [onShow]);

  return (
    <ModalWindow
      open={true}
      onClose={onClose}
      fixed={false}
      width={637}
      content={
        <>
          <UIHeading2>{title}</UIHeading2>
          <UIText1>{message}</UIText1>
        </>
      }
      footer={
        <div className={styles['buttons']}>
          {isChatEnabled && (
            <Button fullWidth onClick={onWriteMessage}>
              Написать сообщение
            </Button>
          )}
          <Button fullWidth theme="fill_white_primary" onClick={onCallAnyway}>
            Всё равно позвонить
          </Button>
        </div>
      }
    />
  );
};
